import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber } from 'libphonenumber-js';

@Pipe({
  name: 'formatPhone',
})
export class FormatPhonePipe implements PipeTransform {
  transform(value: string, args?: string): string {
    if (!value) {
      return value;
    }

    try {
      return parsePhoneNumber(value).formatInternational();
    } catch (e) {
      return value;
    }
  }
}
